import Icon from './icon.vue';
export default Icon;


//////////////////
// WEBPACK FOOTER
// ./~/iview/src/components/icon/index.js
// module id = 258
// module chunks = 1